import { ReactElement, ReactNode } from "react";

import { Field } from "./catalyst/Field";
import { Label } from "./catalyst/Label";

interface DetailFieldProps {
  children: ReactNode;
  label: string;
}

export const GraphDetailField = ({
  children,
  label,
}: DetailFieldProps): ReactElement => (
  <Field className="space-y-2 py-2">
    <Label className="block truncate" color="muted" size="xs">
      {label}
    </Label>
    {children}
  </Field>
);
